import DeleteIcon from "@material-ui/icons/Delete";
import { handleKeyDown } from "../../common/common";

function SplitHireModal(props) {
  const {
    selectedSplitHire = {},
    onChangeSplitHire = () => { },
    addNewSplitHire = () => { },
  } = props;

  const splitHire =
    (selectedSplitHire &&
      selectedSplitHire.splitHire &&
      JSON.parse(selectedSplitHire.splitHire)) ||
    [];

  return (
    <div className="p-0.5">
      <table
        className="split-hire-table fleet-result-table vessel-details-tables w-full border-collapse text-[11px]"
        style={{ border: "1px solid #cbd5e1" }}
      >
        <thead>
          <tr className="bg-[#f0f2f5]">
            <th
              className="text-left font-semibold text-slate-700 px-2 py-1 text-[11px]"
              style={{ border: "1px solid #cbd5e1" }}
            >
              No. of Days
            </th>
            <th
              className="text-left font-semibold text-slate-700 px-2 py-1 text-[11px]"
              style={{ border: "1px solid #cbd5e1" }}
            >
              Hire Rate
            </th>
            <th
              className="text-center font-semibold text-slate-700 px-2 py-1 text-[11px]"
              style={{ border: "1px solid #cbd5e1", width: "64px" }}
            >
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(splitHire) && splitHire.length ? (
            splitHire.map((item, index) => {
              return (
                <tr key={index}>
                  <td
                    className="p-0 bg-[#ffffd6]"
                    style={{ border: "1px solid #cbd5e1" }}
                  >
                    <input
                      type="number"
                      onKeyDown={handleKeyDown}
                      value={item.NoDays}
                      name="NoDays"
                      onChange={(e) => onChangeSplitHire(index, e)}
                      className="w-full h-[22px] px-1.5 text-[11px] bg-[#ffffd6] text-slate-800 border-none focus:bg-white focus:outline focus:outline-[1.5px] focus:outline-[#d97706] focus:-outline-offset-[1.5px]"
                    />
                  </td>
                  <td
                    className="p-0 bg-[#ffffd6]"
                    style={{ border: "1px solid #cbd5e1" }}
                  >
                    <input
                      type="number"
                      onKeyDown={handleKeyDown}
                      value={item.hireRate}
                      name="hireRate"
                      onChange={(e) => onChangeSplitHire(index, e)}
                      className="w-full h-[22px] px-1.5 text-[11px] bg-[#ffffd6] text-slate-800 border-none focus:bg-white focus:outline focus:outline-[1.5px] focus:outline-[#d97706] focus:-outline-offset-[1.5px]"
                    />
                  </td>
                  <td
                    className="p-0 text-center bg-white align-middle"
                    style={{ border: "1px solid #cbd5e1" }}
                  >
                    <DeleteIcon
                      style={{ cursor: "pointer", color: "blue", fontSize: 15 }}
                      onClick={(e) => onChangeSplitHire(index, e, true)}
                    />
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td
                colSpan={3}
                className="p-2 text-center text-slate-500 text-[11px] bg-white"
                style={{ border: "1px solid #cbd5e1" }}
              >
                No data found.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <button
        type="button"
        onClick={addNewSplitHire}
        className="mt-2.5 px-2.5 py-1 bg-[#313C4C] text-white text-[11px] font-semibold rounded hover:bg-[#0c2f50] transition-colors cursor-pointer"
      >
        + Add
      </button>
    </div>
  );
}

export default SplitHireModal;
